<template>
  <svg width="32"
       height="32"
       viewBox="0 0 32 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7715_43080)">
      <g clip-path="url(#clip1_7715_43080)">
        <path d="M6.81348 6.47037C7.26599 6.24803 8.45465 5.78055 10.3926 5.95767C12.9718 6.33184 15.0707 6.64725 16.2471 6.82877C14.8169 7.13624 13.3952 7.53401 12.127 8.03678L12.1299 8.04264C11.4315 8.38226 10.9493 9.09865 10.9492 9.9274C10.9492 11.084 11.8874 12.0217 13.0439 12.0221C13.3255 12.0221 13.5947 11.9666 13.8398 11.8659C14.0377 11.8028 14.2489 11.7346 14.4678 11.6637L14.4707 11.6618C15.4243 11.3528 16.8294 10.8662 17.5957 10.7135C17.833 10.6663 18.0678 10.7545 18.25 10.9137L27.3438 18.8747C27.3454 18.8732 27.347 18.8713 27.3486 18.8698L27.3633 18.8825C28.3346 19.7318 28.384 21.2258 27.4707 22.1374C26.9622 22.6448 26.2656 22.8581 25.5996 22.7692C26.057 23.6667 25.9194 24.7984 25.1641 25.5602C24.4775 26.2527 23.4685 26.4445 22.6035 26.1188C22.5854 26.7052 22.3545 27.2878 21.9062 27.7399C21.1134 28.5396 19.8906 28.6716 18.9561 28.11C18.8675 28.5688 18.646 29.008 18.291 29.3669C17.3807 30.2868 15.9121 30.3413 14.9365 29.4909L14.833 29.4001L16.1348 28.0553C16.893 27.3112 16.8325 25.8799 16.1348 25.0788C15.6598 24.5337 14.9858 24.294 14.3467 24.3874C14.7789 23.6344 14.61 22.6258 14.0723 22.0104C13.5275 21.3872 12.7854 21.1482 12.1279 21.2907C12.4715 20.4759 12.307 19.4754 11.6484 18.8288C10.9518 18.145 9.88516 18.0445 9.0625 18.4967C9.19114 17.8447 9.02873 17.1445 8.56152 16.6081C7.71238 15.6334 6.21278 15.5874 5.30566 16.5085L3.60254 18.237C2.57554 16.9457 1.96193 15.3109 1.96191 13.5329C1.96191 10.3115 3.97589 7.56051 6.81348 6.47037Z"
              fill="url(#paint0_linear_7715_43080)"
        />
        <path d="M6.81348 6.47037C7.26599 6.24803 8.45465 5.78055 10.3926 5.95767C12.9718 6.33184 15.0707 6.64725 16.2471 6.82877C14.8169 7.13624 13.3952 7.53401 12.127 8.03678L12.1299 8.04264C11.4315 8.38226 10.9493 9.09865 10.9492 9.9274C10.9492 11.084 11.8874 12.0217 13.0439 12.0221C13.3255 12.0221 13.5947 11.9666 13.8398 11.8659C14.0377 11.8028 14.2489 11.7346 14.4678 11.6637L14.4707 11.6618C15.4243 11.3528 16.8294 10.8662 17.5957 10.7135C17.833 10.6663 18.0678 10.7545 18.25 10.9137L27.3438 18.8747C27.3454 18.8732 27.347 18.8713 27.3486 18.8698L27.3633 18.8825C28.3346 19.7318 28.384 21.2258 27.4707 22.1374C26.9622 22.6448 26.2656 22.8581 25.5996 22.7692C26.057 23.6667 25.9194 24.7984 25.1641 25.5602C24.4775 26.2527 23.4685 26.4445 22.6035 26.1188C22.5854 26.7052 22.3545 27.2878 21.9062 27.7399C21.1134 28.5396 19.8906 28.6716 18.9561 28.11C18.8675 28.5688 18.646 29.008 18.291 29.3669C17.3807 30.2868 15.9121 30.3413 14.9365 29.4909L14.833 29.4001L16.1348 28.0553C16.893 27.3112 16.8325 25.8799 16.1348 25.0788C15.6598 24.5337 14.9858 24.294 14.3467 24.3874C14.7789 23.6344 14.61 22.6258 14.0723 22.0104C13.5275 21.3872 12.7854 21.1482 12.1279 21.2907C12.4715 20.4759 12.307 19.4754 11.6484 18.8288C10.9518 18.145 9.88516 18.0445 9.0625 18.4967C9.19114 17.8447 9.02873 17.1445 8.56152 16.6081C7.71238 15.6334 6.21278 15.5874 5.30566 16.5085L3.60254 18.237C2.57554 16.9457 1.96193 15.3109 1.96191 13.5329C1.96191 10.3115 3.97589 7.56051 6.81348 6.47037Z"
              fill="url(#paint1_radial_7715_43080)"
        />
        <path d="M6.81348 6.47037C7.26599 6.24803 8.45465 5.78055 10.3926 5.95767C12.9718 6.33184 15.0707 6.64725 16.2471 6.82877C14.8169 7.13624 13.3952 7.53401 12.127 8.03678L12.1299 8.04264C11.4315 8.38226 10.9493 9.09865 10.9492 9.9274C10.9492 11.084 11.8874 12.0217 13.0439 12.0221C13.3255 12.0221 13.5947 11.9666 13.8398 11.8659C14.0377 11.8028 14.2489 11.7346 14.4678 11.6637L14.4707 11.6618C15.4243 11.3528 16.8294 10.8662 17.5957 10.7135C17.833 10.6663 18.0678 10.7545 18.25 10.9137L27.3438 18.8747C27.3454 18.8732 27.347 18.8713 27.3486 18.8698L27.3633 18.8825C28.3346 19.7318 28.384 21.2258 27.4707 22.1374C26.9622 22.6448 26.2656 22.8581 25.5996 22.7692C26.057 23.6667 25.9194 24.7984 25.1641 25.5602C24.4775 26.2527 23.4685 26.4445 22.6035 26.1188C22.5854 26.7052 22.3545 27.2878 21.9062 27.7399C21.1134 28.5396 19.8906 28.6716 18.9561 28.11C18.8675 28.5688 18.646 29.008 18.291 29.3669C17.3807 30.2868 15.9121 30.3413 14.9365 29.4909L14.833 29.4001L16.1348 28.0553C16.893 27.3112 16.8325 25.8799 16.1348 25.0788C15.6598 24.5337 14.9858 24.294 14.3467 24.3874C14.7789 23.6344 14.61 22.6258 14.0723 22.0104C13.5275 21.3872 12.7854 21.1482 12.1279 21.2907C12.4715 20.4759 12.307 19.4754 11.6484 18.8288C10.9518 18.145 9.88516 18.0445 9.0625 18.4967C9.19114 17.8447 9.02873 17.1445 8.56152 16.6081C7.71238 15.6334 6.21278 15.5874 5.30566 16.5085L3.60254 18.237C2.57554 16.9457 1.96193 15.3109 1.96191 13.5329C1.96191 10.3115 3.97589 7.56051 6.81348 6.47037Z"
              fill="url(#paint2_radial_7715_43080)"
        />
        <path d="M6.81348 6.47037C7.26599 6.24803 8.45465 5.78055 10.3926 5.95767C12.9718 6.33184 15.0707 6.64725 16.2471 6.82877C14.8169 7.13624 13.3952 7.53401 12.127 8.03678L12.1299 8.04264C11.4315 8.38226 10.9493 9.09865 10.9492 9.9274C10.9492 11.084 11.8874 12.0217 13.0439 12.0221C13.3255 12.0221 13.5947 11.9666 13.8398 11.8659C14.0377 11.8028 14.2489 11.7346 14.4678 11.6637L14.4707 11.6618C15.4243 11.3528 16.8294 10.8662 17.5957 10.7135C17.833 10.6663 18.0678 10.7545 18.25 10.9137L27.3438 18.8747C27.3454 18.8732 27.347 18.8713 27.3486 18.8698L27.3633 18.8825C28.3346 19.7318 28.384 21.2258 27.4707 22.1374C26.9622 22.6448 26.2656 22.8581 25.5996 22.7692C26.057 23.6667 25.9194 24.7984 25.1641 25.5602C24.4775 26.2527 23.4685 26.4445 22.6035 26.1188C22.5854 26.7052 22.3545 27.2878 21.9062 27.7399C21.1134 28.5396 19.8906 28.6716 18.9561 28.11C18.8675 28.5688 18.646 29.008 18.291 29.3669C17.3807 30.2868 15.9121 30.3413 14.9365 29.4909L14.833 29.4001L16.1348 28.0553C16.893 27.3112 16.8325 25.8799 16.1348 25.0788C15.6598 24.5337 14.9858 24.294 14.3467 24.3874C14.7789 23.6344 14.61 22.6258 14.0723 22.0104C13.5275 21.3872 12.7854 21.1482 12.1279 21.2907C12.4715 20.4759 12.307 19.4754 11.6484 18.8288C10.9518 18.145 9.88516 18.0445 9.0625 18.4967C9.19114 17.8447 9.02873 17.1445 8.56152 16.6081C7.71238 15.6334 6.21278 15.5874 5.30566 16.5085L3.60254 18.237C2.57554 16.9457 1.96193 15.3109 1.96191 13.5329C1.96191 10.3115 3.97589 7.56051 6.81348 6.47037Z"
              fill="url(#paint3_radial_7715_43080)"
        />
        <path d="M6.81348 6.47037C7.26599 6.24803 8.45465 5.78055 10.3926 5.95767C12.9718 6.33184 15.0707 6.64725 16.2471 6.82877C14.8169 7.13624 13.3952 7.53401 12.127 8.03678L12.1299 8.04264C11.4315 8.38226 10.9493 9.09865 10.9492 9.9274C10.9492 11.084 11.8874 12.0217 13.0439 12.0221C13.3255 12.0221 13.5947 11.9666 13.8398 11.8659C14.0377 11.8028 14.2489 11.7346 14.4678 11.6637L14.4707 11.6618C15.4243 11.3528 16.8294 10.8662 17.5957 10.7135C17.833 10.6663 18.0678 10.7545 18.25 10.9137L27.3438 18.8747C27.3454 18.8732 27.347 18.8713 27.3486 18.8698L27.3633 18.8825C28.3346 19.7318 28.384 21.2258 27.4707 22.1374C26.9622 22.6448 26.2656 22.8581 25.5996 22.7692C26.057 23.6667 25.9194 24.7984 25.1641 25.5602C24.4775 26.2527 23.4685 26.4445 22.6035 26.1188C22.5854 26.7052 22.3545 27.2878 21.9062 27.7399C21.1134 28.5396 19.8906 28.6716 18.9561 28.11C18.8675 28.5688 18.646 29.008 18.291 29.3669C17.3807 30.2868 15.9121 30.3413 14.9365 29.4909L14.833 29.4001L16.1348 28.0553C16.893 27.3112 16.8325 25.8799 16.1348 25.0788C15.6598 24.5337 14.9858 24.294 14.3467 24.3874C14.7789 23.6344 14.61 22.6258 14.0723 22.0104C13.5275 21.3872 12.7854 21.1482 12.1279 21.2907C12.4715 20.4759 12.307 19.4754 11.6484 18.8288C10.9518 18.145 9.88516 18.0445 9.0625 18.4967C9.19114 17.8447 9.02873 17.1445 8.56152 16.6081C7.71238 15.6334 6.21278 15.5874 5.30566 16.5085L3.60254 18.237C2.57554 16.9457 1.96193 15.3109 1.96191 13.5329C1.96191 10.3115 3.97589 7.56051 6.81348 6.47037Z"
              fill="url(#paint4_radial_7715_43080)"
        />
        <path d="M6.81348 6.47037C7.26599 6.24803 8.45465 5.78055 10.3926 5.95767C12.9718 6.33184 15.0707 6.64725 16.2471 6.82877C14.8169 7.13624 13.3952 7.53401 12.127 8.03678L12.1299 8.04264C11.4315 8.38226 10.9493 9.09865 10.9492 9.9274C10.9492 11.084 11.8874 12.0217 13.0439 12.0221C13.3255 12.0221 13.5947 11.9666 13.8398 11.8659C14.0377 11.8028 14.2489 11.7346 14.4678 11.6637L14.4707 11.6618C15.4243 11.3528 16.8294 10.8662 17.5957 10.7135C17.833 10.6663 18.0678 10.7545 18.25 10.9137L27.3438 18.8747C27.3454 18.8732 27.347 18.8713 27.3486 18.8698L27.3633 18.8825C28.3346 19.7318 28.384 21.2258 27.4707 22.1374C26.9622 22.6448 26.2656 22.8581 25.5996 22.7692C26.057 23.6667 25.9194 24.7984 25.1641 25.5602C24.4775 26.2527 23.4685 26.4445 22.6035 26.1188C22.5854 26.7052 22.3545 27.2878 21.9062 27.7399C21.1134 28.5396 19.8906 28.6716 18.9561 28.11C18.8675 28.5688 18.646 29.008 18.291 29.3669C17.3807 30.2868 15.9121 30.3413 14.9365 29.4909L14.833 29.4001L16.1348 28.0553C16.893 27.3112 16.8325 25.8799 16.1348 25.0788C15.6598 24.5337 14.9858 24.294 14.3467 24.3874C14.7789 23.6344 14.61 22.6258 14.0723 22.0104C13.5275 21.3872 12.7854 21.1482 12.1279 21.2907C12.4715 20.4759 12.307 19.4754 11.6484 18.8288C10.9518 18.145 9.88516 18.0445 9.0625 18.4967C9.19114 17.8447 9.02873 17.1445 8.56152 16.6081C7.71238 15.6334 6.21278 15.5874 5.30566 16.5085L3.60254 18.237C2.57554 16.9457 1.96193 15.3109 1.96191 13.5329C1.96191 10.3115 3.97589 7.56051 6.81348 6.47037Z"
              fill="url(#paint5_radial_7715_43080)"
        />
        <path d="M6.81348 6.47037C7.26599 6.24803 8.45465 5.78055 10.3926 5.95767C12.9718 6.33184 15.0707 6.64725 16.2471 6.82877C14.8169 7.13624 13.3952 7.53401 12.127 8.03678L12.1299 8.04264C11.4315 8.38226 10.9493 9.09865 10.9492 9.9274C10.9492 11.084 11.8874 12.0217 13.0439 12.0221C13.3255 12.0221 13.5947 11.9666 13.8398 11.8659C14.0377 11.8028 14.2489 11.7346 14.4678 11.6637L14.4707 11.6618C15.4243 11.3528 16.8294 10.8662 17.5957 10.7135C17.833 10.6663 18.0678 10.7545 18.25 10.9137L27.3438 18.8747C27.3454 18.8732 27.347 18.8713 27.3486 18.8698L27.3633 18.8825C28.3346 19.7318 28.384 21.2258 27.4707 22.1374C26.9622 22.6448 26.2656 22.8581 25.5996 22.7692C26.057 23.6667 25.9194 24.7984 25.1641 25.5602C24.4775 26.2527 23.4685 26.4445 22.6035 26.1188C22.5854 26.7052 22.3545 27.2878 21.9062 27.7399C21.1134 28.5396 19.8906 28.6716 18.9561 28.11C18.8675 28.5688 18.646 29.008 18.291 29.3669C17.3807 30.2868 15.9121 30.3413 14.9365 29.4909L14.833 29.4001L16.1348 28.0553C16.893 27.3112 16.8325 25.8799 16.1348 25.0788C15.6598 24.5337 14.9858 24.294 14.3467 24.3874C14.7789 23.6344 14.61 22.6258 14.0723 22.0104C13.5275 21.3872 12.7854 21.1482 12.1279 21.2907C12.4715 20.4759 12.307 19.4754 11.6484 18.8288C10.9518 18.145 9.88516 18.0445 9.0625 18.4967C9.19114 17.8447 9.02873 17.1445 8.56152 16.6081C7.71238 15.6334 6.21278 15.5874 5.30566 16.5085L3.60254 18.237C2.57554 16.9457 1.96193 15.3109 1.96191 13.5329C1.96191 10.3115 3.97589 7.56051 6.81348 6.47037Z"
              fill="url(#paint6_radial_7715_43080)"
        />
        <path d="M6.81348 6.47037C7.26599 6.24803 8.45465 5.78055 10.3926 5.95767C12.9718 6.33184 15.0707 6.64725 16.2471 6.82877C14.8169 7.13624 13.3952 7.53401 12.127 8.03678L12.1299 8.04264C11.4315 8.38226 10.9493 9.09865 10.9492 9.9274C10.9492 11.084 11.8874 12.0217 13.0439 12.0221C13.3255 12.0221 13.5947 11.9666 13.8398 11.8659C14.0377 11.8028 14.2489 11.7346 14.4678 11.6637L14.4707 11.6618C15.4243 11.3528 16.8294 10.8662 17.5957 10.7135C17.833 10.6663 18.0678 10.7545 18.25 10.9137L27.3438 18.8747C27.3454 18.8732 27.347 18.8713 27.3486 18.8698L27.3633 18.8825C28.3346 19.7318 28.384 21.2258 27.4707 22.1374C26.9622 22.6448 26.2656 22.8581 25.5996 22.7692C26.057 23.6667 25.9194 24.7984 25.1641 25.5602C24.4775 26.2527 23.4685 26.4445 22.6035 26.1188C22.5854 26.7052 22.3545 27.2878 21.9062 27.7399C21.1134 28.5396 19.8906 28.6716 18.9561 28.11C18.8675 28.5688 18.646 29.008 18.291 29.3669C17.3807 30.2868 15.9121 30.3413 14.9365 29.4909L14.833 29.4001L16.1348 28.0553C16.893 27.3112 16.8325 25.8799 16.1348 25.0788C15.6598 24.5337 14.9858 24.294 14.3467 24.3874C14.7789 23.6344 14.61 22.6258 14.0723 22.0104C13.5275 21.3872 12.7854 21.1482 12.1279 21.2907C12.4715 20.4759 12.307 19.4754 11.6484 18.8288C10.9518 18.145 9.88516 18.0445 9.0625 18.4967C9.19114 17.8447 9.02873 17.1445 8.56152 16.6081C7.71238 15.6334 6.21278 15.5874 5.30566 16.5085L3.60254 18.237C2.57554 16.9457 1.96193 15.3109 1.96191 13.5329C1.96191 10.3115 3.97589 7.56051 6.81348 6.47037Z"
              fill="url(#paint7_radial_7715_43080)"
        />
        <path d="M6.81348 6.47037C7.26599 6.24803 8.45465 5.78055 10.3926 5.95767C12.9718 6.33184 15.0707 6.64725 16.2471 6.82877C14.8169 7.13624 13.3952 7.53401 12.127 8.03678L12.1299 8.04264C11.4315 8.38226 10.9493 9.09865 10.9492 9.9274C10.9492 11.084 11.8874 12.0217 13.0439 12.0221C13.3255 12.0221 13.5947 11.9666 13.8398 11.8659C14.0377 11.8028 14.2489 11.7346 14.4678 11.6637L14.4707 11.6618C15.4243 11.3528 16.8294 10.8662 17.5957 10.7135C17.833 10.6663 18.0678 10.7545 18.25 10.9137L27.3438 18.8747C27.3454 18.8732 27.347 18.8713 27.3486 18.8698L27.3633 18.8825C28.3346 19.7318 28.384 21.2258 27.4707 22.1374C26.9622 22.6448 26.2656 22.8581 25.5996 22.7692C26.057 23.6667 25.9194 24.7984 25.1641 25.5602C24.4775 26.2527 23.4685 26.4445 22.6035 26.1188C22.5854 26.7052 22.3545 27.2878 21.9062 27.7399C21.1134 28.5396 19.8906 28.6716 18.9561 28.11C18.8675 28.5688 18.646 29.008 18.291 29.3669C17.3807 30.2868 15.9121 30.3413 14.9365 29.4909L14.833 29.4001L16.1348 28.0553C16.893 27.3112 16.8325 25.8799 16.1348 25.0788C15.6598 24.5337 14.9858 24.294 14.3467 24.3874C14.7789 23.6344 14.61 22.6258 14.0723 22.0104C13.5275 21.3872 12.7854 21.1482 12.1279 21.2907C12.4715 20.4759 12.307 19.4754 11.6484 18.8288C10.9518 18.145 9.88516 18.0445 9.0625 18.4967C9.19114 17.8447 9.02873 17.1445 8.56152 16.6081C7.71238 15.6334 6.21278 15.5874 5.30566 16.5085L3.60254 18.237C2.57554 16.9457 1.96193 15.3109 1.96191 13.5329C1.96191 10.3115 3.97589 7.56051 6.81348 6.47037Z"
              fill="url(#paint8_radial_7715_43080)"
        />
        <path d="M6.81348 6.47037C7.26599 6.24803 8.45465 5.78055 10.3926 5.95767C12.9718 6.33184 15.0707 6.64725 16.2471 6.82877C14.8169 7.13624 13.3952 7.53401 12.127 8.03678L12.1299 8.04264C11.4315 8.38226 10.9493 9.09865 10.9492 9.9274C10.9492 11.084 11.8874 12.0217 13.0439 12.0221C13.3255 12.0221 13.5947 11.9666 13.8398 11.8659C14.0377 11.8028 14.2489 11.7346 14.4678 11.6637L14.4707 11.6618C15.4243 11.3528 16.8294 10.8662 17.5957 10.7135C17.833 10.6663 18.0678 10.7545 18.25 10.9137L27.3438 18.8747C27.3454 18.8732 27.347 18.8713 27.3486 18.8698L27.3633 18.8825C28.3346 19.7318 28.384 21.2258 27.4707 22.1374C26.9622 22.6448 26.2656 22.8581 25.5996 22.7692C26.057 23.6667 25.9194 24.7984 25.1641 25.5602C24.4775 26.2527 23.4685 26.4445 22.6035 26.1188C22.5854 26.7052 22.3545 27.2878 21.9062 27.7399C21.1134 28.5396 19.8906 28.6716 18.9561 28.11C18.8675 28.5688 18.646 29.008 18.291 29.3669C17.3807 30.2868 15.9121 30.3413 14.9365 29.4909L14.833 29.4001L16.1348 28.0553C16.893 27.3112 16.8325 25.8799 16.1348 25.0788C15.6598 24.5337 14.9858 24.294 14.3467 24.3874C14.7789 23.6344 14.61 22.6258 14.0723 22.0104C13.5275 21.3872 12.7854 21.1482 12.1279 21.2907C12.4715 20.4759 12.307 19.4754 11.6484 18.8288C10.9518 18.145 9.88516 18.0445 9.0625 18.4967C9.19114 17.8447 9.02873 17.1445 8.56152 16.6081C7.71238 15.6334 6.21278 15.5874 5.30566 16.5085L3.60254 18.237C2.57554 16.9457 1.96193 15.3109 1.96191 13.5329C1.96191 10.3115 3.97589 7.56051 6.81348 6.47037Z"
              fill="url(#paint9_radial_7715_43080)"
        />
        <path d="M6.81348 6.47037C7.26599 6.24803 8.45465 5.78055 10.3926 5.95767C12.9718 6.33184 15.0707 6.64725 16.2471 6.82877C14.8169 7.13624 13.3952 7.53401 12.127 8.03678L12.1299 8.04264C11.4315 8.38226 10.9493 9.09865 10.9492 9.9274C10.9492 11.084 11.8874 12.0217 13.0439 12.0221C13.3255 12.0221 13.5947 11.9666 13.8398 11.8659C14.0377 11.8028 14.2489 11.7346 14.4678 11.6637L14.4707 11.6618C15.4243 11.3528 16.8294 10.8662 17.5957 10.7135C17.833 10.6663 18.0678 10.7545 18.25 10.9137L27.3438 18.8747C27.3454 18.8732 27.347 18.8713 27.3486 18.8698L27.3633 18.8825C28.3346 19.7318 28.384 21.2258 27.4707 22.1374C26.9622 22.6448 26.2656 22.8581 25.5996 22.7692C26.057 23.6667 25.9194 24.7984 25.1641 25.5602C24.4775 26.2527 23.4685 26.4445 22.6035 26.1188C22.5854 26.7052 22.3545 27.2878 21.9062 27.7399C21.1134 28.5396 19.8906 28.6716 18.9561 28.11C18.8675 28.5688 18.646 29.008 18.291 29.3669C17.3807 30.2868 15.9121 30.3413 14.9365 29.4909L14.833 29.4001L16.1348 28.0553C16.893 27.3112 16.8325 25.8799 16.1348 25.0788C15.6598 24.5337 14.9858 24.294 14.3467 24.3874C14.7789 23.6344 14.61 22.6258 14.0723 22.0104C13.5275 21.3872 12.7854 21.1482 12.1279 21.2907C12.4715 20.4759 12.307 19.4754 11.6484 18.8288C10.9518 18.145 9.88516 18.0445 9.0625 18.4967C9.19114 17.8447 9.02873 17.1445 8.56152 16.6081C7.71238 15.6334 6.21278 15.5874 5.30566 16.5085L3.60254 18.237C2.57554 16.9457 1.96193 15.3109 1.96191 13.5329C1.96191 10.3115 3.97589 7.56051 6.81348 6.47037Z"
              fill="url(#paint10_radial_7715_43080)"
              fill-opacity="0.8"
        />
        <path d="M6.81348 6.47037C7.26599 6.24803 8.45465 5.78055 10.3926 5.95767C12.9718 6.33184 15.0707 6.64725 16.2471 6.82877C14.8169 7.13624 13.3952 7.53401 12.127 8.03678L12.1299 8.04264C11.4315 8.38226 10.9493 9.09865 10.9492 9.9274C10.9492 11.084 11.8874 12.0217 13.0439 12.0221C13.3255 12.0221 13.5947 11.9666 13.8398 11.8659C14.0377 11.8028 14.2489 11.7346 14.4678 11.6637L14.4707 11.6618C15.4243 11.3528 16.8294 10.8662 17.5957 10.7135C17.833 10.6663 18.0678 10.7545 18.25 10.9137L27.3438 18.8747C27.3454 18.8732 27.347 18.8713 27.3486 18.8698L27.3633 18.8825C28.3346 19.7318 28.384 21.2258 27.4707 22.1374C26.9622 22.6448 26.2656 22.8581 25.5996 22.7692C26.057 23.6667 25.9194 24.7984 25.1641 25.5602C24.4775 26.2527 23.4685 26.4445 22.6035 26.1188C22.5854 26.7052 22.3545 27.2878 21.9062 27.7399C21.1134 28.5396 19.8906 28.6716 18.9561 28.11C18.8675 28.5688 18.646 29.008 18.291 29.3669C17.3807 30.2868 15.9121 30.3413 14.9365 29.4909L14.833 29.4001L16.1348 28.0553C16.893 27.3112 16.8325 25.8799 16.1348 25.0788C15.6598 24.5337 14.9858 24.294 14.3467 24.3874C14.7789 23.6344 14.61 22.6258 14.0723 22.0104C13.5275 21.3872 12.7854 21.1482 12.1279 21.2907C12.4715 20.4759 12.307 19.4754 11.6484 18.8288C10.9518 18.145 9.88516 18.0445 9.0625 18.4967C9.19114 17.8447 9.02873 17.1445 8.56152 16.6081C7.71238 15.6334 6.21278 15.5874 5.30566 16.5085L3.60254 18.237C2.57554 16.9457 1.96193 15.3109 1.96191 13.5329C1.96191 10.3115 3.97589 7.56051 6.81348 6.47037Z"
              fill="url(#paint11_radial_7715_43080)"
              fill-opacity="0.8"
        />
        <path d="M6.81348 6.47037C7.26599 6.24803 8.45465 5.78055 10.3926 5.95767C12.9718 6.33184 15.0707 6.64725 16.2471 6.82877C14.8169 7.13624 13.3952 7.53401 12.127 8.03678L12.1299 8.04264C11.4315 8.38226 10.9493 9.09865 10.9492 9.9274C10.9492 11.084 11.8874 12.0217 13.0439 12.0221C13.3255 12.0221 13.5947 11.9666 13.8398 11.8659C14.0377 11.8028 14.2489 11.7346 14.4678 11.6637L14.4707 11.6618C15.4243 11.3528 16.8294 10.8662 17.5957 10.7135C17.833 10.6663 18.0678 10.7545 18.25 10.9137L27.3438 18.8747C27.3454 18.8732 27.347 18.8713 27.3486 18.8698L27.3633 18.8825C28.3346 19.7318 28.384 21.2258 27.4707 22.1374C26.9622 22.6448 26.2656 22.8581 25.5996 22.7692C26.057 23.6667 25.9194 24.7984 25.1641 25.5602C24.4775 26.2527 23.4685 26.4445 22.6035 26.1188C22.5854 26.7052 22.3545 27.2878 21.9062 27.7399C21.1134 28.5396 19.8906 28.6716 18.9561 28.11C18.8675 28.5688 18.646 29.008 18.291 29.3669C17.3807 30.2868 15.9121 30.3413 14.9365 29.4909L14.833 29.4001L16.1348 28.0553C16.893 27.3112 16.8325 25.8799 16.1348 25.0788C15.6598 24.5337 14.9858 24.294 14.3467 24.3874C14.7789 23.6344 14.61 22.6258 14.0723 22.0104C13.5275 21.3872 12.7854 21.1482 12.1279 21.2907C12.4715 20.4759 12.307 19.4754 11.6484 18.8288C10.9518 18.145 9.88516 18.0445 9.0625 18.4967C9.19114 17.8447 9.02873 17.1445 8.56152 16.6081C7.71238 15.6334 6.21278 15.5874 5.30566 16.5085L3.60254 18.237C2.57554 16.9457 1.96193 15.3109 1.96191 13.5329C1.96191 10.3115 3.97589 7.56051 6.81348 6.47037Z"
              fill="url(#paint12_radial_7715_43080)"
              fill-opacity="0.8"
        />
        <path d="M6.81348 6.47037C7.26599 6.24803 8.45465 5.78055 10.3926 5.95767C12.9718 6.33184 15.0707 6.64725 16.2471 6.82877C14.8169 7.13624 13.3952 7.53401 12.127 8.03678L12.1299 8.04264C11.4315 8.38226 10.9493 9.09865 10.9492 9.9274C10.9492 11.084 11.8874 12.0217 13.0439 12.0221C13.3255 12.0221 13.5947 11.9666 13.8398 11.8659C14.0377 11.8028 14.2489 11.7346 14.4678 11.6637L14.4707 11.6618C15.4243 11.3528 16.8294 10.8662 17.5957 10.7135C17.833 10.6663 18.0678 10.7545 18.25 10.9137L27.3438 18.8747C27.3454 18.8732 27.347 18.8713 27.3486 18.8698L27.3633 18.8825C28.3346 19.7318 28.384 21.2258 27.4707 22.1374C26.9622 22.6448 26.2656 22.8581 25.5996 22.7692C26.057 23.6667 25.9194 24.7984 25.1641 25.5602C24.4775 26.2527 23.4685 26.4445 22.6035 26.1188C22.5854 26.7052 22.3545 27.2878 21.9062 27.7399C21.1134 28.5396 19.8906 28.6716 18.9561 28.11C18.8675 28.5688 18.646 29.008 18.291 29.3669C17.3807 30.2868 15.9121 30.3413 14.9365 29.4909L14.833 29.4001L16.1348 28.0553C16.893 27.3112 16.8325 25.8799 16.1348 25.0788C15.6598 24.5337 14.9858 24.294 14.3467 24.3874C14.7789 23.6344 14.61 22.6258 14.0723 22.0104C13.5275 21.3872 12.7854 21.1482 12.1279 21.2907C12.4715 20.4759 12.307 19.4754 11.6484 18.8288C10.9518 18.145 9.88516 18.0445 9.0625 18.4967C9.19114 17.8447 9.02873 17.1445 8.56152 16.6081C7.71238 15.6334 6.21278 15.5874 5.30566 16.5085L3.60254 18.237C2.57554 16.9457 1.96193 15.3109 1.96191 13.5329C1.96191 10.3115 3.97589 7.56051 6.81348 6.47037Z"
              fill="url(#paint13_radial_7715_43080)"
              fill-opacity="0.3"
        />
        <path d="M6.81348 6.47037C7.26599 6.24803 8.45465 5.78055 10.3926 5.95767C12.9718 6.33184 15.0707 6.64725 16.2471 6.82877C14.8169 7.13624 13.3952 7.53401 12.127 8.03678L12.1299 8.04264C11.4315 8.38226 10.9493 9.09865 10.9492 9.9274C10.9492 11.084 11.8874 12.0217 13.0439 12.0221C13.3255 12.0221 13.5947 11.9666 13.8398 11.8659C14.0377 11.8028 14.2489 11.7346 14.4678 11.6637L14.4707 11.6618C15.4243 11.3528 16.8294 10.8662 17.5957 10.7135C17.833 10.6663 18.0678 10.7545 18.25 10.9137L27.3438 18.8747C27.3454 18.8732 27.347 18.8713 27.3486 18.8698L27.3633 18.8825C28.3346 19.7318 28.384 21.2258 27.4707 22.1374C26.9622 22.6448 26.2656 22.8581 25.5996 22.7692C26.057 23.6667 25.9194 24.7984 25.1641 25.5602C24.4775 26.2527 23.4685 26.4445 22.6035 26.1188C22.5854 26.7052 22.3545 27.2878 21.9062 27.7399C21.1134 28.5396 19.8906 28.6716 18.9561 28.11C18.8675 28.5688 18.646 29.008 18.291 29.3669C17.3807 30.2868 15.9121 30.3413 14.9365 29.4909L14.833 29.4001L16.1348 28.0553C16.893 27.3112 16.8325 25.8799 16.1348 25.0788C15.6598 24.5337 14.9858 24.294 14.3467 24.3874C14.7789 23.6344 14.61 22.6258 14.0723 22.0104C13.5275 21.3872 12.7854 21.1482 12.1279 21.2907C12.4715 20.4759 12.307 19.4754 11.6484 18.8288C10.9518 18.145 9.88516 18.0445 9.0625 18.4967C9.19114 17.8447 9.02873 17.1445 8.56152 16.6081C7.71238 15.6334 6.21278 15.5874 5.30566 16.5085L3.60254 18.237C2.57554 16.9457 1.96193 15.3109 1.96191 13.5329C1.96191 10.3115 3.97589 7.56051 6.81348 6.47037Z"
              fill="url(#paint14_radial_7715_43080)"
        />
        <path d="M6.81348 6.47037C7.26599 6.24803 8.45465 5.78055 10.3926 5.95767C12.9718 6.33184 15.0707 6.64725 16.2471 6.82877C14.8169 7.13624 13.3952 7.53401 12.127 8.03678L12.1299 8.04264C11.4315 8.38226 10.9493 9.09865 10.9492 9.9274C10.9492 11.084 11.8874 12.0217 13.0439 12.0221C13.3255 12.0221 13.5947 11.9666 13.8398 11.8659C14.0377 11.8028 14.2489 11.7346 14.4678 11.6637L14.4707 11.6618C15.4243 11.3528 16.8294 10.8662 17.5957 10.7135C17.833 10.6663 18.0678 10.7545 18.25 10.9137L27.3438 18.8747C27.3454 18.8732 27.347 18.8713 27.3486 18.8698L27.3633 18.8825C28.3346 19.7318 28.384 21.2258 27.4707 22.1374C26.9622 22.6448 26.2656 22.8581 25.5996 22.7692C26.057 23.6667 25.9194 24.7984 25.1641 25.5602C24.4775 26.2527 23.4685 26.4445 22.6035 26.1188C22.5854 26.7052 22.3545 27.2878 21.9062 27.7399C21.1134 28.5396 19.8906 28.6716 18.9561 28.11C18.8675 28.5688 18.646 29.008 18.291 29.3669C17.3807 30.2868 15.9121 30.3413 14.9365 29.4909L14.833 29.4001L16.1348 28.0553C16.893 27.3112 16.8325 25.8799 16.1348 25.0788C15.6598 24.5337 14.9858 24.294 14.3467 24.3874C14.7789 23.6344 14.61 22.6258 14.0723 22.0104C13.5275 21.3872 12.7854 21.1482 12.1279 21.2907C12.4715 20.4759 12.307 19.4754 11.6484 18.8288C10.9518 18.145 9.88516 18.0445 9.0625 18.4967C9.19114 17.8447 9.02873 17.1445 8.56152 16.6081C7.71238 15.6334 6.21278 15.5874 5.30566 16.5085L3.60254 18.237C2.57554 16.9457 1.96193 15.3109 1.96191 13.5329C1.96191 10.3115 3.97589 7.56051 6.81348 6.47037Z"
              fill="url(#paint15_radial_7715_43080)"
        />
        <path d="M6.81348 6.47037C7.26599 6.24803 8.45465 5.78055 10.3926 5.95767C12.9718 6.33184 15.0707 6.64725 16.2471 6.82877C14.8169 7.13624 13.3952 7.53401 12.127 8.03678L12.1299 8.04264C11.4315 8.38226 10.9493 9.09865 10.9492 9.9274C10.9492 11.084 11.8874 12.0217 13.0439 12.0221C13.3255 12.0221 13.5947 11.9666 13.8398 11.8659C14.0377 11.8028 14.2489 11.7346 14.4678 11.6637L14.4707 11.6618C15.4243 11.3528 16.8294 10.8662 17.5957 10.7135C17.833 10.6663 18.0678 10.7545 18.25 10.9137L27.3438 18.8747C27.3454 18.8732 27.347 18.8713 27.3486 18.8698L27.3633 18.8825C28.3346 19.7318 28.384 21.2258 27.4707 22.1374C26.9622 22.6448 26.2656 22.8581 25.5996 22.7692C26.057 23.6667 25.9194 24.7984 25.1641 25.5602C24.4775 26.2527 23.4685 26.4445 22.6035 26.1188C22.5854 26.7052 22.3545 27.2878 21.9062 27.7399C21.1134 28.5396 19.8906 28.6716 18.9561 28.11C18.8675 28.5688 18.646 29.008 18.291 29.3669C17.3807 30.2868 15.9121 30.3413 14.9365 29.4909L14.833 29.4001L16.1348 28.0553C16.893 27.3112 16.8325 25.8799 16.1348 25.0788C15.6598 24.5337 14.9858 24.294 14.3467 24.3874C14.7789 23.6344 14.61 22.6258 14.0723 22.0104C13.5275 21.3872 12.7854 21.1482 12.1279 21.2907C12.4715 20.4759 12.307 19.4754 11.6484 18.8288C10.9518 18.145 9.88516 18.0445 9.0625 18.4967C9.19114 17.8447 9.02873 17.1445 8.56152 16.6081C7.71238 15.6334 6.21278 15.5874 5.30566 16.5085L3.60254 18.237C2.57554 16.9457 1.96193 15.3109 1.96191 13.5329C1.96191 10.3115 3.97589 7.56051 6.81348 6.47037Z"
              fill="url(#paint16_radial_7715_43080)"
        />
        <path d="M6.81348 6.47037C7.26599 6.24803 8.45465 5.78055 10.3926 5.95767C12.9718 6.33184 15.0707 6.64725 16.2471 6.82877C14.8169 7.13624 13.3952 7.53401 12.127 8.03678L12.1299 8.04264C11.4315 8.38226 10.9493 9.09865 10.9492 9.9274C10.9492 11.084 11.8874 12.0217 13.0439 12.0221C13.3255 12.0221 13.5947 11.9666 13.8398 11.8659C14.0377 11.8028 14.2489 11.7346 14.4678 11.6637L14.4707 11.6618C15.4243 11.3528 16.8294 10.8662 17.5957 10.7135C17.833 10.6663 18.0678 10.7545 18.25 10.9137L27.3438 18.8747C27.3454 18.8732 27.347 18.8713 27.3486 18.8698L27.3633 18.8825C28.3346 19.7318 28.384 21.2258 27.4707 22.1374C26.9622 22.6448 26.2656 22.8581 25.5996 22.7692C26.057 23.6667 25.9194 24.7984 25.1641 25.5602C24.4775 26.2527 23.4685 26.4445 22.6035 26.1188C22.5854 26.7052 22.3545 27.2878 21.9062 27.7399C21.1134 28.5396 19.8906 28.6716 18.9561 28.11C18.8675 28.5688 18.646 29.008 18.291 29.3669C17.3807 30.2868 15.9121 30.3413 14.9365 29.4909L14.833 29.4001L16.1348 28.0553C16.893 27.3112 16.8325 25.8799 16.1348 25.0788C15.6598 24.5337 14.9858 24.294 14.3467 24.3874C14.7789 23.6344 14.61 22.6258 14.0723 22.0104C13.5275 21.3872 12.7854 21.1482 12.1279 21.2907C12.4715 20.4759 12.307 19.4754 11.6484 18.8288C10.9518 18.145 9.88516 18.0445 9.0625 18.4967C9.19114 17.8447 9.02873 17.1445 8.56152 16.6081C7.71238 15.6334 6.21278 15.5874 5.30566 16.5085L3.60254 18.237C2.57554 16.9457 1.96193 15.3109 1.96191 13.5329C1.96191 10.3115 3.97589 7.56051 6.81348 6.47037Z"
              fill="url(#paint17_radial_7715_43080)"
        />
        <path d="M6.81348 6.47037C7.26599 6.24803 8.45465 5.78055 10.3926 5.95767C12.9718 6.33184 15.0707 6.64725 16.2471 6.82877C14.8169 7.13624 13.3952 7.53401 12.127 8.03678L12.1299 8.04264C11.4315 8.38226 10.9493 9.09865 10.9492 9.9274C10.9492 11.084 11.8874 12.0217 13.0439 12.0221C13.3255 12.0221 13.5947 11.9666 13.8398 11.8659C14.0377 11.8028 14.2489 11.7346 14.4678 11.6637L14.4707 11.6618C15.4243 11.3528 16.8294 10.8662 17.5957 10.7135C17.833 10.6663 18.0678 10.7545 18.25 10.9137L27.3438 18.8747C27.3454 18.8732 27.347 18.8713 27.3486 18.8698L27.3633 18.8825C28.3346 19.7318 28.384 21.2258 27.4707 22.1374C26.9622 22.6448 26.2656 22.8581 25.5996 22.7692C26.057 23.6667 25.9194 24.7984 25.1641 25.5602C24.4775 26.2527 23.4685 26.4445 22.6035 26.1188C22.5854 26.7052 22.3545 27.2878 21.9062 27.7399C21.1134 28.5396 19.8906 28.6716 18.9561 28.11C18.8675 28.5688 18.646 29.008 18.291 29.3669C17.3807 30.2868 15.9121 30.3413 14.9365 29.4909L14.833 29.4001L16.1348 28.0553C16.893 27.3112 16.8325 25.8799 16.1348 25.0788C15.6598 24.5337 14.9858 24.294 14.3467 24.3874C14.7789 23.6344 14.61 22.6258 14.0723 22.0104C13.5275 21.3872 12.7854 21.1482 12.1279 21.2907C12.4715 20.4759 12.307 19.4754 11.6484 18.8288C10.9518 18.145 9.88516 18.0445 9.0625 18.4967C9.19114 17.8447 9.02873 17.1445 8.56152 16.6081C7.71238 15.6334 6.21278 15.5874 5.30566 16.5085L3.60254 18.237C2.57554 16.9457 1.96193 15.3109 1.96191 13.5329C1.96191 10.3115 3.97589 7.56051 6.81348 6.47037Z"
              fill="url(#paint18_radial_7715_43080)"
        />
        <path d="M6.81348 6.47037C7.26599 6.24803 8.45465 5.78055 10.3926 5.95767C12.9718 6.33184 15.0707 6.64725 16.2471 6.82877C14.8169 7.13624 13.3952 7.53401 12.127 8.03678L12.1299 8.04264C11.4315 8.38226 10.9493 9.09865 10.9492 9.9274C10.9492 11.084 11.8874 12.0217 13.0439 12.0221C13.3255 12.0221 13.5947 11.9666 13.8398 11.8659C14.0377 11.8028 14.2489 11.7346 14.4678 11.6637L14.4707 11.6618C15.4243 11.3528 16.8294 10.8662 17.5957 10.7135C17.833 10.6663 18.0678 10.7545 18.25 10.9137L27.3438 18.8747C27.3454 18.8732 27.347 18.8713 27.3486 18.8698L27.3633 18.8825C28.3346 19.7318 28.384 21.2258 27.4707 22.1374C26.9622 22.6448 26.2656 22.8581 25.5996 22.7692C26.057 23.6667 25.9194 24.7984 25.1641 25.5602C24.4775 26.2527 23.4685 26.4445 22.6035 26.1188C22.5854 26.7052 22.3545 27.2878 21.9062 27.7399C21.1134 28.5396 19.8906 28.6716 18.9561 28.11C18.8675 28.5688 18.646 29.008 18.291 29.3669C17.3807 30.2868 15.9121 30.3413 14.9365 29.4909L14.833 29.4001L16.1348 28.0553C16.893 27.3112 16.8325 25.8799 16.1348 25.0788C15.6598 24.5337 14.9858 24.294 14.3467 24.3874C14.7789 23.6344 14.61 22.6258 14.0723 22.0104C13.5275 21.3872 12.7854 21.1482 12.1279 21.2907C12.4715 20.4759 12.307 19.4754 11.6484 18.8288C10.9518 18.145 9.88516 18.0445 9.0625 18.4967C9.19114 17.8447 9.02873 17.1445 8.56152 16.6081C7.71238 15.6334 6.21278 15.5874 5.30566 16.5085L3.60254 18.237C2.57554 16.9457 1.96193 15.3109 1.96191 13.5329C1.96191 10.3115 3.97589 7.56051 6.81348 6.47037Z"
              fill="url(#paint19_radial_7715_43080)"
        />
        <path d="M6.81348 6.47037C7.26599 6.24803 8.45465 5.78055 10.3926 5.95767C12.9718 6.33184 15.0707 6.64725 16.2471 6.82877C14.8169 7.13624 13.3952 7.53401 12.127 8.03678L12.1299 8.04264C11.4315 8.38226 10.9493 9.09865 10.9492 9.9274C10.9492 11.084 11.8874 12.0217 13.0439 12.0221C13.3255 12.0221 13.5947 11.9666 13.8398 11.8659C14.0377 11.8028 14.2489 11.7346 14.4678 11.6637L14.4707 11.6618C15.4243 11.3528 16.8294 10.8662 17.5957 10.7135C17.833 10.6663 18.0678 10.7545 18.25 10.9137L27.3438 18.8747C27.3454 18.8732 27.347 18.8713 27.3486 18.8698L27.3633 18.8825C28.3346 19.7318 28.384 21.2258 27.4707 22.1374C26.9622 22.6448 26.2656 22.8581 25.5996 22.7692C26.057 23.6667 25.9194 24.7984 25.1641 25.5602C24.4775 26.2527 23.4685 26.4445 22.6035 26.1188C22.5854 26.7052 22.3545 27.2878 21.9062 27.7399C21.1134 28.5396 19.8906 28.6716 18.9561 28.11C18.8675 28.5688 18.646 29.008 18.291 29.3669C17.3807 30.2868 15.9121 30.3413 14.9365 29.4909L14.833 29.4001L16.1348 28.0553C16.893 27.3112 16.8325 25.8799 16.1348 25.0788C15.6598 24.5337 14.9858 24.294 14.3467 24.3874C14.7789 23.6344 14.61 22.6258 14.0723 22.0104C13.5275 21.3872 12.7854 21.1482 12.1279 21.2907C12.4715 20.4759 12.307 19.4754 11.6484 18.8288C10.9518 18.145 9.88516 18.0445 9.0625 18.4967C9.19114 17.8447 9.02873 17.1445 8.56152 16.6081C7.71238 15.6334 6.21278 15.5874 5.30566 16.5085L3.60254 18.237C2.57554 16.9457 1.96193 15.3109 1.96191 13.5329C1.96191 10.3115 3.97589 7.56051 6.81348 6.47037Z"
              fill="url(#paint20_radial_7715_43080)"
        />
        <path d="M3.40671 21.2587C2.68443 20.3901 2.73809 19.1154 3.53081 18.3105L5.30625 16.5079C6.21348 15.5868 7.71282 15.6327 8.56191 16.6077C9.3334 17.4936 9.28117 18.8271 8.44277 19.65L6.64156 21.5155C5.7241 22.4159 4.22859 22.2472 3.40671 21.2587Z"
              fill="url(#paint21_linear_7715_43080)"
        />
        <path d="M3.40671 21.2587C2.68443 20.3901 2.73809 19.1154 3.53081 18.3105L5.30625 16.5079C6.21348 15.5868 7.71282 15.6327 8.56191 16.6077C9.3334 17.4936 9.28117 18.8271 8.44277 19.65L6.64156 21.5155C5.7241 22.4159 4.22859 22.2472 3.40671 21.2587Z"
              fill="url(#paint22_linear_7715_43080)"
        />
        <path d="M3.40671 21.2587C2.68443 20.3901 2.73809 19.1154 3.53081 18.3105L5.30625 16.5079C6.21348 15.5868 7.71282 15.6327 8.56191 16.6077C9.3334 17.4936 9.28117 18.8271 8.44277 19.65L6.64156 21.5155C5.7241 22.4159 4.22859 22.2472 3.40671 21.2587Z"
              fill="url(#paint23_radial_7715_43080)"
        />
        <path d="M3.40671 21.2587C2.68443 20.3901 2.73809 19.1154 3.53081 18.3105L5.30625 16.5079C6.21348 15.5868 7.71282 15.6327 8.56191 16.6077C9.3334 17.4936 9.28117 18.8271 8.44277 19.65L6.64156 21.5155C5.7241 22.4159 4.22859 22.2472 3.40671 21.2587Z"
              fill="url(#paint24_radial_7715_43080)"
        />
        <path d="M3.40671 21.2587C2.68443 20.3901 2.73809 19.1154 3.53081 18.3105L5.30625 16.5079C6.21348 15.5868 7.71282 15.6327 8.56191 16.6077C9.3334 17.4936 9.28117 18.8271 8.44277 19.65L6.64156 21.5155C5.7241 22.4159 4.22859 22.2472 3.40671 21.2587Z"
              fill="url(#paint25_linear_7715_43080)"
        />
        <path d="M6.00493 24.5295C5.16909 23.6966 5.16114 22.3456 5.9871 21.5029L8.55496 18.883C9.39108 18.0299 10.7964 17.9919 11.6487 18.8288C12.504 19.6686 12.5307 21.1072 11.6859 21.9576L9.10098 24.6262C8.26355 25.4692 6.8466 25.3683 6.00493 24.5295Z"
              fill="url(#paint26_linear_7715_43080)"
        />
        <path d="M6.00493 24.5295C5.16909 23.6966 5.16114 22.3456 5.9871 21.5029L8.55496 18.883C9.39108 18.0299 10.7964 17.9919 11.6487 18.8288C12.504 19.6686 12.5307 21.1072 11.6859 21.9576L9.10098 24.6262C8.26355 25.4692 6.8466 25.3683 6.00493 24.5295Z"
              fill="url(#paint27_linear_7715_43080)"
        />
        <path d="M6.00493 24.5295C5.16909 23.6966 5.16114 22.3456 5.9871 21.5029L8.55496 18.883C9.39108 18.0299 10.7964 17.9919 11.6487 18.8288C12.504 19.6686 12.5307 21.1072 11.6859 21.9576L9.10098 24.6262C8.26355 25.4692 6.8466 25.3683 6.00493 24.5295Z"
              fill="url(#paint28_radial_7715_43080)"
        />
        <path d="M6.00493 24.5295C5.16909 23.6966 5.16114 22.3456 5.9871 21.5029L8.55496 18.883C9.39108 18.0299 10.7964 17.9919 11.6487 18.8288C12.504 19.6686 12.5307 21.1072 11.6859 21.9576L9.10098 24.6262C8.26355 25.4692 6.8466 25.3683 6.00493 24.5295Z"
              fill="url(#paint29_radial_7715_43080)"
        />
        <path d="M6.00493 24.5295C5.16909 23.6966 5.16114 22.3456 5.9871 21.5029L8.55496 18.883C9.39108 18.0299 10.7964 17.9919 11.6487 18.8288C12.504 19.6686 12.5307 21.1072 11.6859 21.9576L9.10098 24.6262C8.26355 25.4692 6.8466 25.3683 6.00493 24.5295Z"
              fill="url(#paint30_linear_7715_43080)"
        />
        <path d="M11.5405 29.2434C10.8872 28.4578 10.8235 27.2051 11.5404 26.4772L13.2584 24.9468C14.0788 24.1137 15.3671 24.197 16.135 25.0788C16.8328 25.8799 16.8933 27.3112 16.135 28.0553L14.6467 29.5941C13.7288 30.36 12.2837 30.1373 11.5405 29.2434Z"
              fill="url(#paint31_linear_7715_43080)"
        />
        <path d="M11.5405 29.2434C10.8872 28.4578 10.8235 27.2051 11.5404 26.4772L13.2584 24.9468C14.0788 24.1137 15.3671 24.197 16.135 25.0788C16.8328 25.8799 16.8933 27.3112 16.135 28.0553L14.6467 29.5941C13.7288 30.36 12.2837 30.1373 11.5405 29.2434Z"
              fill="url(#paint32_linear_7715_43080)"
        />
        <path d="M11.5405 29.2434C10.8872 28.4578 10.8235 27.2051 11.5404 26.4772L13.2584 24.9468C14.0788 24.1137 15.3671 24.197 16.135 25.0788C16.8328 25.8799 16.8933 27.3112 16.135 28.0553L14.6467 29.5941C13.7288 30.36 12.2837 30.1373 11.5405 29.2434Z"
              fill="url(#paint33_radial_7715_43080)"
        />
        <path d="M11.5405 29.2434C10.8872 28.4578 10.8235 27.2051 11.5404 26.4772L13.2584 24.9468C14.0788 24.1137 15.3671 24.197 16.135 25.0788C16.8328 25.8799 16.8933 27.3112 16.135 28.0553L14.6467 29.5941C13.7288 30.36 12.2837 30.1373 11.5405 29.2434Z"
              fill="url(#paint34_radial_7715_43080)"
        />
        <path d="M11.5405 29.2434C10.8872 28.4578 10.8235 27.2051 11.5404 26.4772L13.2584 24.9468C14.0788 24.1137 15.3671 24.197 16.135 25.0788C16.8328 25.8799 16.8933 27.3112 16.135 28.0553L14.6467 29.5941C13.7288 30.36 12.2837 30.1373 11.5405 29.2434Z"
              fill="url(#paint35_linear_7715_43080)"
        />
        <path d="M9.02385 27.0593C8.26742 26.3029 7.954 25.1221 8.71043 24.3657L11.2674 21.7621C12.0239 21.0057 13.2652 21.0862 14.0728 22.0104C14.7027 22.7313 14.8292 23.9932 14.0728 24.7497L11.7631 27.0593C11.1512 27.7642 9.78027 27.8158 9.02385 27.0593Z"
              fill="url(#paint36_linear_7715_43080)"
        />
        <path d="M9.02385 27.0593C8.26742 26.3029 7.954 25.1221 8.71043 24.3657L11.2674 21.7621C12.0239 21.0057 13.2652 21.0862 14.0728 22.0104C14.7027 22.7313 14.8292 23.9932 14.0728 24.7497L11.7631 27.0593C11.1512 27.7642 9.78027 27.8158 9.02385 27.0593Z"
              fill="url(#paint37_linear_7715_43080)"
        />
        <path d="M9.02385 27.0593C8.26742 26.3029 7.954 25.1221 8.71043 24.3657L11.2674 21.7621C12.0239 21.0057 13.2652 21.0862 14.0728 22.0104C14.7027 22.7313 14.8292 23.9932 14.0728 24.7497L11.7631 27.0593C11.1512 27.7642 9.78027 27.8158 9.02385 27.0593Z"
              fill="url(#paint38_radial_7715_43080)"
        />
        <path d="M9.02385 27.0593C8.26742 26.3029 7.954 25.1221 8.71043 24.3657L11.2674 21.7621C12.0239 21.0057 13.2652 21.0862 14.0728 22.0104C14.7027 22.7313 14.8292 23.9932 14.0728 24.7497L11.7631 27.0593C11.1512 27.7642 9.78027 27.8158 9.02385 27.0593Z"
              fill="url(#paint39_radial_7715_43080)"
        />
        <path d="M9.02385 27.0593C8.26742 26.3029 7.954 25.1221 8.71043 24.3657L11.2674 21.7621C12.0239 21.0057 13.2652 21.0862 14.0728 22.0104C14.7027 22.7313 14.8292 23.9932 14.0728 24.7497L11.7631 27.0593C11.1512 27.7642 9.78027 27.8158 9.02385 27.0593Z"
              fill="url(#paint40_linear_7715_43080)"
        />
        <path d="M12.1275 8.03638L12.1299 8.04228C11.4314 8.38187 10.95 9.09833 10.95 9.92723C10.95 11.0841 11.8878 12.0219 13.0446 12.0219C13.3263 12.0219 13.595 11.9663 13.8403 11.8655C14.0383 11.8023 14.2489 11.7341 14.4679 11.6632L14.4713 11.662C15.4251 11.353 16.8299 10.8662 17.5962 10.7137C17.8338 10.6664 18.0684 10.7543 18.2507 10.914L27.3442 18.875C28.99 17.4291 30.0893 15.4597 30.0893 13.1768C30.0893 9.19347 26.935 5.96436 22.8202 5.96436C19.9986 6.10386 15.5167 6.69288 12.1275 8.03638Z"
              fill="#FBB439"
        />
        <path d="M12.1275 8.03638L12.1299 8.04228C11.4314 8.38187 10.95 9.09833 10.95 9.92723C10.95 11.0841 11.8878 12.0219 13.0446 12.0219C13.3263 12.0219 13.595 11.9663 13.8403 11.8655C14.0383 11.8023 14.2489 11.7341 14.4679 11.6632L14.4713 11.662C15.4251 11.353 16.8299 10.8662 17.5962 10.7137C17.8338 10.6664 18.0684 10.7543 18.2507 10.914L27.3442 18.875C28.99 17.4291 30.0893 15.4597 30.0893 13.1768C30.0893 9.19347 26.935 5.96436 22.8202 5.96436C19.9986 6.10386 15.5167 6.69288 12.1275 8.03638Z"
              fill="url(#paint41_radial_7715_43080)"
        />
        <path d="M12.1275 8.03638L12.1299 8.04228C11.4314 8.38187 10.95 9.09833 10.95 9.92723C10.95 11.0841 11.8878 12.0219 13.0446 12.0219C13.3263 12.0219 13.595 11.9663 13.8403 11.8655C14.0383 11.8023 14.2489 11.7341 14.4679 11.6632L14.4713 11.662C15.4251 11.353 16.8299 10.8662 17.5962 10.7137C17.8338 10.6664 18.0684 10.7543 18.2507 10.914L27.3442 18.875C28.99 17.4291 30.0893 15.4597 30.0893 13.1768C30.0893 9.19347 26.935 5.96436 22.8202 5.96436C19.9986 6.10386 15.5167 6.69288 12.1275 8.03638Z"
              fill="url(#paint42_radial_7715_43080)"
        />
        <path d="M12.1275 8.03638L12.1299 8.04228C11.4314 8.38187 10.95 9.09833 10.95 9.92723C10.95 11.0841 11.8878 12.0219 13.0446 12.0219C13.3263 12.0219 13.595 11.9663 13.8403 11.8655C14.0383 11.8023 14.2489 11.7341 14.4679 11.6632L14.4713 11.662C15.4251 11.353 16.8299 10.8662 17.5962 10.7137C17.8338 10.6664 18.0684 10.7543 18.2507 10.914L27.3442 18.875C28.99 17.4291 30.0893 15.4597 30.0893 13.1768C30.0893 9.19347 26.935 5.96436 22.8202 5.96436C19.9986 6.10386 15.5167 6.69288 12.1275 8.03638Z"
              fill="url(#paint43_radial_7715_43080)"
        />
        <path d="M12.1275 8.03638L12.1299 8.04228C11.4314 8.38187 10.95 9.09833 10.95 9.92723C10.95 11.0841 11.8878 12.0219 13.0446 12.0219C13.3263 12.0219 13.595 11.9663 13.8403 11.8655C14.0383 11.8023 14.2489 11.7341 14.4679 11.6632L14.4713 11.662C15.4251 11.353 16.8299 10.8662 17.5962 10.7137C17.8338 10.6664 18.0684 10.7543 18.2507 10.914L27.3442 18.875C28.99 17.4291 30.0893 15.4597 30.0893 13.1768C30.0893 9.19347 26.935 5.96436 22.8202 5.96436C19.9986 6.10386 15.5167 6.69288 12.1275 8.03638Z"
              fill="url(#paint44_radial_7715_43080)"
        />
        <path d="M12.1275 8.03638L12.1299 8.04228C11.4314 8.38187 10.95 9.09833 10.95 9.92723C10.95 11.0841 11.8878 12.0219 13.0446 12.0219C13.3263 12.0219 13.595 11.9663 13.8403 11.8655C14.0383 11.8023 14.2489 11.7341 14.4679 11.6632L14.4713 11.662C15.4251 11.353 16.8299 10.8662 17.5962 10.7137C17.8338 10.6664 18.0684 10.7543 18.2507 10.914L27.3442 18.875C28.99 17.4291 30.0893 15.4597 30.0893 13.1768C30.0893 9.19347 26.935 5.96436 22.8202 5.96436C19.9986 6.10386 15.5167 6.69288 12.1275 8.03638Z"
              fill="url(#paint45_radial_7715_43080)"
        />
        <path d="M12.1275 8.03638L12.1299 8.04228C11.4314 8.38187 10.95 9.09833 10.95 9.92723C10.95 11.0841 11.8878 12.0219 13.0446 12.0219C13.3263 12.0219 13.595 11.9663 13.8403 11.8655C14.0383 11.8023 14.2489 11.7341 14.4679 11.6632L14.4713 11.662C15.4251 11.353 16.8299 10.8662 17.5962 10.7137C17.8338 10.6664 18.0684 10.7543 18.2507 10.914L27.3442 18.875C28.99 17.4291 30.0893 15.4597 30.0893 13.1768C30.0893 9.19347 26.935 5.96436 22.8202 5.96436C19.9986 6.10386 15.5167 6.69288 12.1275 8.03638Z"
              fill="url(#paint46_radial_7715_43080)"
        />
        <path d="M12.1275 8.03638L12.1299 8.04228C11.4314 8.38187 10.95 9.09833 10.95 9.92723C10.95 11.0841 11.8878 12.0219 13.0446 12.0219C13.3263 12.0219 13.595 11.9663 13.8403 11.8655C14.0383 11.8023 14.2489 11.7341 14.4679 11.6632L14.4713 11.662C15.4251 11.353 16.8299 10.8662 17.5962 10.7137C17.8338 10.6664 18.0684 10.7543 18.2507 10.914L27.3442 18.875C28.99 17.4291 30.0893 15.4597 30.0893 13.1768C30.0893 9.19347 26.935 5.96436 22.8202 5.96436C19.9986 6.10386 15.5167 6.69288 12.1275 8.03638Z"
              fill="url(#paint47_radial_7715_43080)"
        />
        <path d="M12.1275 8.03638L12.1299 8.04228C11.4314 8.38187 10.95 9.09833 10.95 9.92723C10.95 11.0841 11.8878 12.0219 13.0446 12.0219C13.3263 12.0219 13.595 11.9663 13.8403 11.8655C14.0383 11.8023 14.2489 11.7341 14.4679 11.6632L14.4713 11.662C15.4251 11.353 16.8299 10.8662 17.5962 10.7137C17.8338 10.6664 18.0684 10.7543 18.2507 10.914L27.3442 18.875C28.99 17.4291 30.0893 15.4597 30.0893 13.1768C30.0893 9.19347 26.935 5.96436 22.8202 5.96436C19.9986 6.10386 15.5167 6.69288 12.1275 8.03638Z"
              fill="url(#paint48_radial_7715_43080)"
        />
        <path d="M12.1275 8.03638L12.1299 8.04228C11.4314 8.38187 10.95 9.09833 10.95 9.92723C10.95 11.0841 11.8878 12.0219 13.0446 12.0219C13.3263 12.0219 13.595 11.9663 13.8403 11.8655C14.0383 11.8023 14.2489 11.7341 14.4679 11.6632L14.4713 11.662C15.4251 11.353 16.8299 10.8662 17.5962 10.7137C17.8338 10.6664 18.0684 10.7543 18.2507 10.914L27.3442 18.875C28.99 17.4291 30.0893 15.4597 30.0893 13.1768C30.0893 9.19347 26.935 5.96436 22.8202 5.96436C19.9986 6.10386 15.5167 6.69288 12.1275 8.03638Z"
              fill="url(#paint49_radial_7715_43080)"
        />
      </g>
    </g>
    <defs>
      <linearGradient id="paint0_linear_7715_43080"
                      x1="22.5881"
                      y1="14.032"
                      x2="15.9004"
                      y2="23.8445"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFD741" />
        <stop offset="1"
              stop-color="#FFBE37"
        />
      </linearGradient>
      <radialGradient id="paint1_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(-2.56248 4.00003 -5.562 -3.56323 19.9631 10.4695)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFDC38" />
        <stop offset="1"
              stop-color="#FFDC38"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint2_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(4.49995 -2.00002 1.93533 4.35456 11.9999 10.5002)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.21875"
              stop-color="#D77A15"
        />
        <stop offset="1"
              stop-color="#FFD83D"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint3_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(8.49992 -4.00004 1.17483 2.49655 17.4998 9.00015)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.21875"
              stop-color="#D77A15"
        />
        <stop offset="1"
              stop-color="#FFD83D"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint4_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(2.49997 4.50004 -6.373 3.54062 27.4997 27.582)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F48E5A" />
        <stop offset="1"
              stop-color="#F48E5A"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint5_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(2.99997 6.00005 -2.83192 1.41599 23.9998 31.582)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F48E5A" />
        <stop offset="1"
              stop-color="#F48E5A"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint6_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(-4.37496 -4.50004 1.2293 -1.19517 24.463 27.1138)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F48E5A" />
        <stop offset="1"
              stop-color="#F48E5A"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint7_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(-3.40622 -3.53128 1.11969 -1.08007 20.0881 28.9576)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F48E5A" />
        <stop offset="1"
              stop-color="#F48E5A"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint8_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(-4.24996 -3.65628 1.07171 -1.24577 16.6819 30.9264)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F48E5A" />
        <stop offset="1"
              stop-color="#F48E5A"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint9_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(13.9999 -5.50005 9.29218 23.6532 2 16.0002)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D77A15" />
        <stop offset="0.688636"
              stop-color="#FFD83D"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint10_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(-5.99994 -6.00005 1.88572 -1.88575 24.4998 18.0819)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0630782"
              stop-color="#FFE746"
        />
        <stop offset="0.882148"
              stop-color="#FFE746"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint11_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(-3.99996 -4.00003 1.21119 -1.21121 21.9998 21.5819)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0630782"
              stop-color="#FFE746"
        />
        <stop offset="0.882148"
              stop-color="#FFE746"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint12_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(-3.49997 -3.50003 1.12656 -1.12658 19.9998 25.082)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFE746" />
        <stop offset="0.882148"
              stop-color="#FFE746"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint13_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(-3.49996 -4.50004 1.44256 -1.12201 16.9999 27.582)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFE746" />
        <stop offset="0.882148"
              stop-color="#FFE746"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint14_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(-3.53122 -3.09378 0.845143 -0.964676 27.0568 23.0513)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F48E5A" />
        <stop offset="1"
              stop-color="#F48E5A"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint15_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(1.99998 4.50004 -4.49995 2.00002 29.9997 24.0819)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F48E5A" />
        <stop offset="1"
              stop-color="#F48E5A"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint16_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(1.99998 4.50004 -4.49995 2.00002 29.9997 24.0819)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F48E5A" />
        <stop offset="1"
              stop-color="#F48E5A"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint17_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(4.13676 4.46369 -4.4636 4.13684 15.0434 26.7727)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.107699"
              stop-color="#CA6D03"
        />
        <stop offset="0.448933"
              stop-color="#CA6D03"
              stop-opacity="0.28"
        />
        <stop offset="0.663014"
              stop-color="#FDBF3F"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint18_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(4.73784 4.04246 -4.04238 4.73793 12.8211 24.1839)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.138062"
              stop-color="#CA6D03"
        />
        <stop offset="0.448933"
              stop-color="#CA6D03"
              stop-opacity="0.28"
        />
        <stop offset="0.663014"
              stop-color="#FDBF3F"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint19_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(4.08711 4.24747 -4.24739 4.08719 10.4794 20.9494)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.139139"
              stop-color="#CA6D03"
        />
        <stop offset="0.448933"
              stop-color="#CA6D03"
              stop-opacity="0.28"
        />
        <stop offset="0.663014"
              stop-color="#FDBF3F"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint20_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(3.28572 4.12726 -4.12718 3.28578 7.75461 18.7055)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.18617"
              stop-color="#CA6D03"
        />
        <stop offset="0.379135"
              stop-color="#CA6D03"
              stop-opacity="0.28"
        />
        <stop offset="0.663014"
              stop-color="#FDBF3F"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint21_linear_7715_43080"
                      x1="7.68195"
                      y1="17.1567"
                      x2="3.3382"
                      y2="21.3442"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFBC41" />
        <stop offset="1"
              stop-color="#E69429"
        />
      </linearGradient>
      <linearGradient id="paint22_linear_7715_43080"
                      x1="7.29132"
                      y1="21.1723"
                      x2="6.32257"
                      y2="20.1411"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E08407" />
        <stop offset="1"
              stop-color="#E08407"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint23_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(5.2757 22.813) rotate(-88.8767) scale(3.18811 2.88295)"
      >
        <stop stop-color="#DA725B" />
        <stop offset="1"
              stop-color="#DA725B"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint24_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(8.51007 16.438) rotate(136.229) scale(2.5749 2.49023)"
      >
        <stop stop-color="#FFE43E" />
        <stop offset="1"
              stop-color="#FFE43E"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint25_linear_7715_43080"
                      x1="9.10776"
                      y1="22.9939"
                      x2="4.59761"
                      y2="17.6716"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.415573"
              stop-color="#CA6D03"
        />
        <stop offset="0.535716"
              stop-color="#CA6D03"
              stop-opacity="0.28"
        />
        <stop offset="0.663014"
              stop-color="#FDBF3F"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint26_linear_7715_43080"
                      x1="10.7132"
                      y1="19.6857"
                      x2="5.86261"
                      y2="24.3609"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFBC41" />
        <stop offset="1"
              stop-color="#E69429"
        />
      </linearGradient>
      <linearGradient id="paint27_linear_7715_43080"
                      x1="10.2771"
                      y1="24.1699"
                      x2="9.19526"
                      y2="23.0185"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E08407" />
        <stop offset="1"
              stop-color="#E08407"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint28_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(7.55701 25.8446) rotate(-83.0945) scale(4.15863 4.91442)"
      >
        <stop stop-color="#E8766E" />
        <stop offset="1"
              stop-color="#E8766E"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint29_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(-1.74518 1.68374 -1.62807 -1.68812 11.307 19.1884)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFE43E" />
        <stop offset="1"
              stop-color="#FFE43E"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint30_linear_7715_43080"
                      x1="11.6023"
                      y1="25.2107"
                      x2="7.26866"
                      y2="20.2614"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.39276"
              stop-color="#CA6D03"
        />
        <stop offset="0.535716"
              stop-color="#CA6D03"
              stop-opacity="0.28"
        />
        <stop offset="0.663014"
              stop-color="#FDBF3F"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint31_linear_7715_43080"
                      x1="15.3827"
                      y1="25.5596"
                      x2="11.4318"
                      y2="29.3735"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFBC41" />
        <stop offset="1"
              stop-color="#E69429"
        />
      </linearGradient>
      <linearGradient id="paint32_linear_7715_43080"
                      x1="12.0569"
                      y1="26.1256"
                      x2="13.4619"
                      y2="27.0338"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.155618"
              stop-color="#E08407"
        />
        <stop offset="1"
              stop-color="#E08407"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint33_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(0.375 -3.63103 4.29755 0.442232 12.7756 30.8444)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E8766E" />
        <stop offset="1"
              stop-color="#E8766E"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint34_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(-1.4236 1.37136 -1.32807 -1.37493 15.8671 25.1546)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFE43E" />
        <stop offset="1"
              stop-color="#FFE43E"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint35_linear_7715_43080"
                      x1="11.0264"
                      y1="25.3824"
                      x2="13.6606"
                      y2="28.0238"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.362477"
              stop-color="#CA6D03"
        />
        <stop offset="0.535716"
              stop-color="#CA6D03"
              stop-opacity="0.28"
        />
        <stop offset="0.663014"
              stop-color="#FDBF3F"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint36_linear_7715_43080"
                      x1="13.143"
                      y1="22.5817"
                      x2="8.73042"
                      y2="26.8427"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFBC41" />
        <stop offset="1"
              stop-color="#E69429"
        />
      </linearGradient>
      <linearGradient id="paint37_linear_7715_43080"
                      x1="13.0257"
                      y1="26.9069"
                      x2="12.1055"
                      y2="25.921"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E08407" />
        <stop offset="1"
              stop-color="#E08407"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint38_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(0.455668 -3.75542 4.4462 0.537481 10.2667 28.1842)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E8766E" />
        <stop offset="1"
              stop-color="#E8766E"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint39_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(-1.59044 1.5316 -1.48371 -1.53558 13.6842 22.1294)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFE43E" />
        <stop offset="1"
              stop-color="#FFE43E"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint40_linear_7715_43080"
                      x1="14.2192"
                      y1="28.8805"
                      x2="10.0144"
                      y2="23.0977"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.408711"
              stop-color="#CA6D03"
        />
        <stop offset="0.535716"
              stop-color="#CA6D03"
              stop-opacity="0.28"
        />
        <stop offset="0.663014"
              stop-color="#FDBF3F"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint41_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(19.1777 17.0944) rotate(-33.6901) scale(12.1285 19.0621)"
      >
        <stop offset="0.360862"
              stop-color="#FFE949"
              stop-opacity="0"
        />
        <stop offset="1"
              stop-color="#FFE949"
        />
      </radialGradient>
      <radialGradient id="paint42_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(10.95 10.7346) rotate(-21.4027) scale(4.32093 6.93849)"
      >
        <stop stop-color="#EE9226" />
        <stop offset="1"
              stop-color="#EE9226"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint43_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(18.7047 17.3046) rotate(-38.5505) scale(8.6025 8.20943)"
      >
        <stop stop-color="#F7A91E" />
        <stop offset="1"
              stop-color="#F7A91E"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint44_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(20.2289 15.5176) rotate(-35.9316) scale(11.5542 18.0776)"
      >
        <stop offset="0.660528"
              stop-color="#FFEA49"
              stop-opacity="0"
        />
        <stop offset="1"
              stop-color="#FFEA49"
        />
      </radialGradient>
      <radialGradient id="paint45_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(14.0002 9.5) rotate(-15.9454) scale(14.5602 1.84773)"
      >
        <stop offset="0.0657336"
              stop-color="#FFE746"
        />
        <stop offset="0.882148"
              stop-color="#FFE746"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint46_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(22.0002 7.5) rotate(74.0546) scale(7.28011 19.6652)"
      >
        <stop stop-color="#FDC73F" />
        <stop offset="0.195165"
              stop-color="#FDC73F"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint47_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(21.5002 14.5) rotate(141.34) scale(6.40312 5.84073)"
      >
        <stop offset="0.267528"
              stop-color="#FAAB40"
        />
        <stop offset="0.882148"
              stop-color="#FAAB40"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint48_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(11.5002 11) rotate(149.036) scale(2.91548)"
      >
        <stop offset="0.0657336"
              stop-color="#F4A42F"
        />
        <stop offset="0.882148"
              stop-color="#F4A42F"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint49_radial_7715_43080"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(21.589 15.5774) rotate(43.9634) scale(15.681 5.07311)"
      >
        <stop offset="0.240163"
              stop-color="#CA6D03"
        />
        <stop offset="0.448933"
              stop-color="#CA6D03"
              stop-opacity="0.28"
        />
        <stop offset="0.663014"
              stop-color="#FDBF3F"
              stop-opacity="0"
        />
      </radialGradient>
      <clipPath id="clip0_7715_43080">
        <rect width="32"
              height="32"
              fill="#FFFFFF"
        />
      </clipPath>
      <clipPath id="clip1_7715_43080">
        <rect width="32"
              height="32"
              fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>
